var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserVerifyAge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 101,
    viewBox: "0 0 110 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3794 89.8287C20.5599 77.8891 29.4255 70.278 39.1631 70.2692H59.6997C70.2624 70.2679 78.5984 76.4024 82.2529 89.8568L16.3794 89.8287Z",
    fill: "#3C3D3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7984 31.9944C29.6258 22.9838 36.0556 14.7196 44.9473 11.6711C53.8391 8.62261 69.352 11.472 73.5456 19.9276C79.5885 32.1139 76.8734 47.0372 73.6692 60.2682C71.9982 60.1797 70.3117 60.1101 68.6181 60.0471L66.2256 52.0729V59.9687C53.0244 59.5605 39.2806 59.816 25.5297 60.0804C24.2996 50.7151 23.971 41.005 26.7984 31.9944Z",
    fill: "#FCAFC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.172 60.9997C57.3526 60.9997 66.4163 51.936 66.4163 40.7554C66.4163 29.5748 57.3526 20.5111 46.172 20.5111C34.9914 20.5111 25.9277 29.5748 25.9277 40.7554C25.9277 51.936 34.9914 60.9997 46.172 60.9997Z",
    fill: "#A0616A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9672 16.3644C40.4306 11.8143 49.78 11.691 57.3608 16.0427C64.9416 20.3944 69.55 28.53 69.3846 37.2695C58.7244 37.7598 47.5263 37.8875 36.172 37.9095L33.4866 31.3413L31.9047 37.9137C28.445 37.9137 24.9786 37.9091 21.5053 37.9C21.2175 29.1924 25.5836 20.9891 32.9672 16.3644Z",
    fill: "#FCAFC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1501 28.5037L14.1501 7.07242L35.5813 7.07242",
    stroke: "#DBE5EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1501 56.4412L14.1501 77.8724H35.5813",
    stroke: "#DBE5EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8499 28.5037V7.07242L64.4187 7.07242",
    stroke: "#DBE5EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8499 56.4412V77.8724H64.4187",
    stroke: "#DBE5EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3499 100C101.291 100 109.35 91.9411 109.35 82C109.35 72.0589 101.291 64 91.3499 64C81.4087 64 73.3499 72.0589 73.3499 82C73.3499 91.9411 81.4087 100 91.3499 100Z",
    fill: "#BADEF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1106 92.6738C89.9943 92.6738 89.1013 91.7808 89.1013 90.6645C89.1013 89.5323 89.9943 88.6711 91.1106 88.6711C92.2429 88.6711 93.104 89.5323 93.104 90.6645C93.088 91.7648 92.2429 92.6738 91.1106 92.6738Z",
    fill: "#1F93E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9107 80.873C94.6988 82.6431 93.5506 83.2013 92.9287 84.3335C92.7692 84.6206 92.6735 84.8438 92.6257 85.3382C92.5459 86.0558 91.9081 86.582 91.1905 86.582H91.0948C90.2655 86.582 89.6117 85.8804 89.6914 85.0511C89.7393 84.5089 89.8669 83.9508 90.1699 83.4086C90.9513 82.0212 92.4343 81.192 93.2954 79.9641C94.2044 78.6724 93.6941 76.2484 91.1107 76.2484C89.9785 76.2484 89.229 76.8225 88.7665 77.5082C88.3678 78.0823 87.6662 78.3534 87.0124 78.0823C86.1672 77.7475 85.8642 76.7269 86.3745 75.9933C87.3473 74.574 88.9738 73.5375 91.0788 73.5375C93.439 73.5375 95.0496 74.6059 95.8788 75.9614C96.5805 77.1096 96.9951 79.2624 95.9107 80.873Z",
    fill: "#1F93E9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserVerifyAge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-verify-age.eed5f1807bf41121df48033afcbd9a31.svg";